import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { meAPI } from '../lib/api';
import MonthGrid from '../components/MonthGrid';

export default function MyCalendar() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    // one broad fetch; MonthGrid pages client-side
    meAPI.calendar('', '').then(({ data }) => {
      const projects = data.projects || {};
      setItems(
        data.tasks.map((t) => ({
          id: t.id,
          title: t.title,
          date: t.due_date || t.start_date,
          color: projects[t.project_id]?.color || '#9aa3b2',
          done: Boolean(t.completed_at),
          project_id: t.project_id,
        }))
      );
    });
  }, []);

  return (
    <div className="flex h-full flex-col">
      <h1 className="mb-4 text-lg font-semibold">Calendar</h1>
      <div className="min-h-0 flex-1">
        <MonthGrid
          items={items}
          onItemClick={(it) => navigate(`/projects/${it.project_id}?task=${it.id}`)}
          draggable={false}
        />
      </div>
    </div>
  );
}
